import icons from './loadIcons';
import useImage from 'use-image';
import { Image } from 'react-konva';
import { jobIconFit, columWidth, jobHeight, jobTopMagin } from './workflowConfig';


export function StatusIcon({ x, j, job, y }) {
  const type = job.status;
  let [image] = useImage(
    type === 'ER' ? icons.error
    : type === 'OK' ? icons.success
    : type === 'NE' ? icons.skipped
    : type === 'AB' ? icons.aborted
    : type === 'RU' ? icons.waiting
    : null
  );

  return <Image image={image} x={x} y={ y ? y : ((j+1)*(jobHeight+jobTopMagin)-jobIconFit)}/>;
};

export function JobIcon({ x, j, job }) {
  const type = job.type;
  let [image] = useImage(
    type === 'WF' ? icons.workflow
    : type === 'SI' ? icons.scann
    : type === 'CO' ? icons.check
    : (type === 'FI' || type === "ST") ? icons.events
    : icons.execute
  );

  return <Image image={image} x={x} y={((j+1)*(jobHeight+jobTopMagin)-jobIconFit)}/>;
};

export function StatusColor(type, mode) {
  if(mode !== 'ej') return '#B5B5B5';
  else {
    return !type ? '#B5B5B5'
     : type === 'ER' ? "#F0505A"
     : type === 'OK' ? "#51B948"
     : type === 'NE' ? '#B5B5B5'
     : type === 'AB' ? "#B5B5B5"
     : type === 'RU' ? "#51AEF6"
     : '#B5B5B5';
  }
}

export function AddIcon({ x, y }) {
  const [image] = useImage(icons.add);
  return <Image image={image} x={x} y={y}/>;
};

export function ShareIcon({ x, y }) {
  const [image] = useImage(icons.share);
  return <Image image={image} x={x} y={y}/>;
};

export function generateShapes() {
  return [...Array(10)].map((_, i) => ({
    id: i.toString(),
    x: Math.random() * window.innerWidth,
    y: Math.random() * window.innerHeight,
    rotation: Math.random() * 180,
    isDragging: false,
  }));
}

export function getTypeText(type) {
  return (
    type === 'WF' ? "workflow" :
    type === 'SI' ? "scann" :
    type === 'CO' ? "check" :
    (type === 'FI' || type === 'ST') ? "event" :
    "execute"
  );
}

export function getLineColor(typeConn) {
  if (typeConn === 'succed'){
    return '#51B948';
  }else if (typeConn === 'error'){
    return "#F0505A";
  }else if (typeConn === 'always'){
    return "#0C8CED";
  }else if (typeConn === 'condition'){
    return "#C938E7";
  }else if (typeConn === 'no-dependency'){
    return "#F9C200";
  }else {
    return "#000"
  }
}

export function getDash(typeConn) {
  if (typeConn === 'no-dependency'){
    return [10, 5];
  }else {
    return null;
  }
}

export function formatWfParam(wfParam) {
  const startNode = {
    id_nodo: -1,
    id_Plantilla: -1,
    title: "Start",
    description: "ST",
    type: "ST",
    hasUserAction: [],
    childs: [],
    conn: []
  }

  const wfParamFormatted = wfParam?JSON.parse(JSON.stringify(wfParam)) : [];

  if (wfParamFormatted[0]) {
    wfParamFormatted[0].map((wf) => wf.conn.push({ conx: 'succed', id_nodo: -1 }));
  }

  return [[startNode], ...wfParamFormatted];
}

export function setUpComponentUtils(wf, setWf) {

  function getNodePosition(id_nodo) {
    for (let i=0; i<wf.length;i++){
      const column = wf[i];
      for (let j=0; j<column.length;j++){
        const job = column[j]
        if (job.id_nodo === id_nodo){
          return {
            x:i*columWidth,
            y:j*(jobHeight+jobTopMagin),
            pos:j
          }
        }
      }
    }
    return false;
  }

  function cleanClickJob(id_nodo=-1) {
    for (let i=0; i<wf.length;i++){
      const column = wf[i];
      for (let j=0; j<column.length;j++){
        const job = column[j]
        if (job.id_nodo !== id_nodo){
          job.actions = false;
        }
      }
    }
  }

  function clickJob(job) {
    cleanClickJob(job.id_nodo);
    if (job.actions){
      job.actions = false;
    }else{
      job.actions = true;
    }
    setWf(JSON.parse(JSON.stringify(wf)));
  }

  return {
    getNodePosition,
    cleanClickJob,
    clickJob
  }

}

export function setUpScroll(stage, setStage) {
  function handleWheel(e) {
    e.evt.preventDefault();

    const scaleBy = 1.02;
    const stage = e.target.getStage();
    const oldScale = stage.scaleX();
    const mousePointTo = {
      x: stage.getPointerPosition().x / oldScale - stage.x() / oldScale,
      y: stage.getPointerPosition().y / oldScale - stage.y() / oldScale
    };

    const newScale = e.evt.deltaY < 0 ? oldScale * scaleBy : oldScale / scaleBy;

    setStage({
      scale: newScale,
      x: (stage.getPointerPosition().x / newScale - mousePointTo.x) * newScale,
      y: (stage.getPointerPosition().y / newScale - mousePointTo.y) * newScale
    });
  }

  return { handleWheel };
}
